import React, { useState, useContext, useEffect } from 'react';
import { List, Row, Col, Avatar, Form, Button } from 'antd';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition'
import { DeleteOutlined, EditOutlined, MinusCircleOutlined, RedoOutlined, MinusSquareFilled, AudioOutlined, PauseOutlined, PlayCircleOutlined } from '@ant-design/icons';
import { Modal, WhiteSpace, WingBlank, Icon } from 'antd-mobile';



const VoiceCaptureComp = (props) => {

    const { transcript, resetTranscript, interimTranscript, finalTranscript, listening } = useSpeechRecognition({ clearTranscriptOnListen: false });

    const [transc, settransc] = useState(transcript)
    const [modalVisible, setmodalVisible] = useState(false)
    const [recordTime, setrecordTime] = useState(0)
    const [mediaRecorderInstance, setmediaRecorderInstance] = useState(undefined)
    const [recordedClip, setrecordedClip] = useState(null)
    const [paused, setpaused] = useState(false)
    const [recordingActive, setrecordingActive] = useState(false)
    const [chunksArr, setchunksArr] = useState([])
    const [mediaStream, setmediaStream] = useState(null)


    useEffect(() => {
        settransc(transcript)
    }, [transcript])


    useEffect(() => {
        settransc(transcript)
        setmodalVisible(false)
        setmediaRecorderInstance(undefined)
        setrecordedClip(props.data)
        setpaused(false)
        setrecordingActive(false)
        setchunksArr([])
        setmediaStream(null)
        stopListening()
        stopRecording()
    }, [props.flag])


    useEffect(() => {
        // let str = (props.voiceInput == null ? '' : props.voiceInput) + transc;
        if (listening == true) {
            props.setvoiceInputText(transcript)
        }
    }, [transc])


    const onClose = () => {
        setmodalVisible(false)
    }


    const startRecording = () => {
        setrecordingActive(true)
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            navigator.mediaDevices.getUserMedia(
                // constraints - only audio needed for this app
                {
                    audio: true
                })
                .then(function (stream) {
                    setmediaStream(stream)
                    const mediaRecorder = new MediaRecorder(stream);
                    mediaRecorder.start(1000)
                    setmediaRecorderInstance(mediaRecorder)

                    mediaRecorder.ondataavailable = function (e) {
                        chunksArr.push(e.data);
                        setchunksArr(chunksArr)
                    }
                   
                    mediaRecorder.onstop = function (e) {
                        setrecordingActive(false)
                        const blob = new Blob(chunksArr, { 'type': 'audio/ogg; codecs=opus' });
                        setrecordedClip(blob)
                        const audioURL = window.URL.createObjectURL(blob);
              
                        if (props.setvoiceInputText) {
                            props.setvoiceInputText(undefined, blob)
                        }
                    }

                    mediaRecorder.onpause=function(e){
                        setrecordingActive(false)
                        const blob = new Blob(chunksArr, { 'type': 'audio/ogg; codecs=opus' });
                        setrecordedClip(blob)
                        const audioURL = window.URL.createObjectURL(blob);
                        if (props.setvoiceInputText) {
                            props.setvoiceInputText(undefined, blob)
                        }
                    }
                })
                .catch(function (err) {
                    console.log('The following getUserMedia error occurred: ' + err);
                }
                );
        } else {
            console.log('getUserMedia not supported on your browser!');
        }
    }


    const startListening = () => {
        if (flag == false) {
            // resetTranscript()
            SpeechRecognition.startListening({
                continuous: true
            })
            setpaused(false)
        }
    }



    const stopListening = () => {
        if (flag == true) {
            // SpeechRecognition.stopListening()

            SpeechRecognition.stopListening()
            setpaused(true)

            // resetTranscript()
        }
   
    }

    const deleteVoiceNote = () => {

    }

    const playClip = () => {
        setmodalVisible(true)
    }

    const stopRecording=()=>{
        if(mediaRecorderInstance && (mediaRecorderInstance.state == 'recording' || mediaRecorderInstance.state == 'paused')){
            mediaRecorderInstance.stop()
        }
        if(mediaStream){
            mediaStream.getTracks().forEach(function(track) {
                if (track.readyState == 'live') {
                    track.stop();
                }
            });
        }
    }

    const pauseRecording=()=>{
        if(mediaRecorderInstance && (mediaRecorderInstance.state == 'recording' )){
            mediaRecorderInstance.pause()
        }
        if(mediaStream){
            mediaStream.getTracks().forEach(function(track) {
                if (track.readyState == 'live') {
                    track.stop();
                }
            });
        }
    }

    if (!SpeechRecognition.browserSupportsSpeechRecognition()) {
        return null
    }


    // let flag = SpeechRecognition.getRecognitionManager().listening;
    let flag = listening;

    let recordingFlag = mediaRecorderInstance ? mediaRecorderInstance.state : false;

    let clickHoldTimer = null;

    const handleMouseDown = () => {
        clickHoldTimer = setTimeout(() => {
            if(mediaRecorderInstance.state == 'recording' || mediaRecorderInstance.state == 'paused'){
                stopRecording()
            }
        }, 1000);
    }

    const handleMouseUp = () => {
        clearTimeout(clickHoldTimer);
    }



    return (
        <>
            <div style={{ background: '#00003B', padding: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center', alignContent: 'cener', marginTop:'10px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '250px' }}>
                    {recordedClip ?
                        <PlayCircleOutlined style={{ fontSize: '20px', cursor: 'pointer', color:'white', scale: '1.7' }}
                            onClick={playClip} />
                        :
                        <PlayCircleOutlined
                            style={{ fontSize: '20px', color: '#2f312f', scale: '1.7' }}
                        // onClick={playClip}
                        />
                    }

                    {flag == false ?

                        <AudioOutlined style={{ fontSize: '20px', cursor: 'pointer', color: 'white', scale: '1.7' }}
                            onClick={startListening} />
                        :
                        // <AudioOutlined style={{ fontSize: '20px', color: '#2f312f' }}
                        // // onClick={pauseListening}
                        // />
                        <div style={{ background: flag == true ? '#cd0000' : 'white', width:'20px', height:'20px', borderRadius:'2px', cursor:'pointer', scale: '1.7' }}
                        onClick={stopListening}
                   
                        ></div>
                    }

               
                    {/* <MinusSquareFilled
                        style={{ fontSize: '20px', color: flag == true ? '#cd0000' : 'grey' }}
                        onClick={stopListening} /> */}

                  
                    <div id="recButton" className={recordingFlag == 'recording' ? "Rec" : ''}
                    style={{ background: recordingFlag == 'recording' ? '#cd0000' : recordingFlag == 'paused' ? '#ff9800' :'white', scale: '1.3' }}

                    onTouchStart={handleMouseDown} onTouchEnd={handleMouseUp} 


                       onClick={(e)=>{

                        switch (e.detail) {
                            case 1:
                              if(recordingFlag == 'recording'){
                                  pauseRecording()
                              }else{
                                  startRecording()
                              }
                              break;
                            case 2:
                              console.log("double click");
                              stopRecording()
                              break;
                            case 3:
                              console.log("triple click");
                              break;
                          }

                       
                        // if(recordingActive == false){
                        //     startRecording()
                        // }else{
                        //     stopRecording()
                        // }
                    }}
                    // onDoubleClick={()=>{
                    //     console.log('double click')
                    //     if(mediaRecorderInstance.state == 'recording'){
                    //         stopRecording()
                    //     }else{
                    //         startRecording()
                    //     }
                    // }}
                 
                    ></div>
                    {/* <div style={{fontSize:'12px'}}>{mediaRecorderInstance.state ? mediaRecorderInstance.state == 'inactive' ? 'Stopped' : mediaRecorderInstance.state : ''}</div> */}

               
                </div>

            </div>

            {/* <Row gutter={40} justify="end">
                <Col style={{ marginTop: '5px' }}>
                    <div>
                        <Button
                            onClick={() => {
                                // props.startspeech()

                                if (flag == false) {
                                    resetTranscript()
                                    SpeechRecognition.startListening({
                                        continuous: true
                                    })
                                }
                                if (flag == true) {
                                    SpeechRecognition.stopListening()
                                    // resetTranscript()
                                }
                            }}
                            // disabled={flag == true} 
                            type={flag == true ? 'danger' : 'primary'}
                            style={{ borderRadius: '50%', height: '45px', width: '45px', lineHeight: '48px', textAlign: 'center', padding: '0px' }}

                        // style={flag == true ? {background:'red',color:'white', borderRadius:'50%', height:'50px',width:'50px'} : { borderRadius:'50%', height:'50px',width:'50px'}}
                        >
                            {flag == false ?
                                <AudioOutlined style={{ fontSize: '20px' }} />
                                :
                                <MinusSquareFilled style={{ fontSize: '20px' }} />
                            }

                        </Button>
                      
                    </div>
                </Col>


            </Row> */}


            <Modal
                popup
                visible={modalVisible}
                onClose={onClose}
                animationType="slide-up"
                afterClose={() => { }}
            >
                {modalVisible == true &&
                    <div style={{ padding: '10px', paddingTop:'40px', paddingBottom:'40px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                        {/* <h3>Talk to record</h3> */}
                        <Avatar style={{ backgroundColor: '#87d068', marginBottom:'20px' }}
                            size={{ xs: 64, sm: 64, md: 64, lg: 64, xl: 80, xxl: 100 }}
                            icon={<AudioOutlined />}

                        />
                        <audio id="clip" src={window.URL.createObjectURL(recordedClip)} controls />
                        {/* <DeleteOutlined style={{ fontSize: '20px', cursor: 'pointer', color: '#cd0000' }}
                            onClick={deleteVoiceNote} /> */}
                    </div>

                }
            </Modal>
        </>
    )
}

export default VoiceCaptureComp;